export function stopEvent(e) {
  if (e) {
    e.preventDefault();
  }
}

export function stopEventAndImmediatePropagation(e) {
  if (e) {
    e.preventDefault();
    e.stopImmediatePropagation();
  }
}

export { defaultCountriesForPhone, getCountryList, countryList  } from './defaultCountriesForPhone';
export { default as generateGuid } from './generateGuid.js';
export {
  applyStyleSheet,
  transformStylesToCSS,
  applyTheme,
  useTheme
} from './theme.js'
export * from './input';
